/**
 * Rotierende Texte für die Bildgenerierung
 *
 * Diese werden während der Generierung zufällig angezeigt und rotieren alle 3 Sekunden.
 */

import i18n from '@/i18n'

export function getLoadingMessages(): string[] {
  return i18n.t('generation.loadingMessages', { returnObjects: true }) as string[]
}

// Keep type export for compatibility
export type GenerationLoadingMessage = string
